import styled from "styled-components";

export const ResetButtonRed = styled.button`
  -webkit-tap-highlight-color: white;
  box-sizing: border-box;
  overflow: visible;
  text-transform: none;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  border: 3px solid #0a2240;
  line-height: 1.5;
  transition: all 0.15s ease-in-out;
  background-color: #ffffff;
  padding: 5px 0px;
  color: #0a2240;
  cursor: pointer;
  width: 200px;
  //font-family: 'FuturaPT', sans-serif;

  //&:hover {
  //  background-color: #ff7875;
  //  border-color: #ff7875;
  //}
  //
  //&:active {
  //  background-color: #d9363e;
  //  border-color: #d9363e;
  //}

  //&:focus {
  //  outline: none;
  //  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  //}

  @media (max-width: 578px) {
    width: 150px;
    font-size: 16px;
  }
`;